import apiClient from './client';

// The logged-in user's profile. `_sessionProbe` tells the client this call is
// how the app finds out whether anyone is logged in, so a final 401 just means
// "logged out" rather than a redirect to /login.
export const getMe = () => apiClient.get('/me', { _sessionProbe: true }).then((r) => r.data);

// Only the changed fields. Changing email or password needs `current_password`.
export const updateMe = (payload) => apiClient.patch('/me', payload).then((r) => r.data);

export const deleteMe = (password) =>
  apiClient.delete('/me', { data: { password } }).then(() => undefined);
